import React from 'react'
//import { Link } from 'react-router-dom'
import { HashLink as Link} from 'react-router-hash-link'
import SignIn from '../components/SignIn'
import Register from '../components/Register'
import { isAuthenticated, logout/*, showApiKey*/ } from '../services/self'
import logo from '../Nlogo.png'
import curlyLogo from '../Logo.png'
import newformaAPILogo from '../newformaAPI.png'
//import { getApi } from '../services/api-catalog'

//Newforma Connect

export default class Home extends React.Component{


  logout() {
    logout()
    this.setState({ loggedOut: true })
  }



render() {
  return(

<div className="none">

        <div className="App">
        <div className="Logo">
          <Link className="home-link2" to='/'><img src={logo} className="App-logo" alt="logo" /></Link>
          <Link className="home-link" to='/'>Developer</Link>
        </div>

        <div className="Navbar-Div">
          <nav className="App-navbar">


            <Link className="Centered-link" to='/updates'>Updates</Link>
            <Link className="Centered-link" to='/getting-started'>Getting Started</Link>
            <Link className="Centered-link" to='/documentation'>Docs</Link>
            <Link className="Centered-link" to='/tools'>Tools</Link>
            <Link className="Centered-link" to='/community'>Community</Link>



            <div className="right">
              {isAuthenticated() ? (<Link to='/account'>Account</Link>) : ''}
              {isAuthenticated() ? (<Link to='' onClick={() => this.logout()}>Log out</Link>) : ''}
            </div>

            {isAuthenticated() ? '' : (
              <span className="right">
              <SignIn />
              <Register />
              </span>
            )}


          </nav>
        </div>

        <div className="App-banner">

      <span className="orange-bold">  Newforma </span> Your partner for all things AECO project information management. <a className="newforma-world-link" href="https://www.newforma.com/">Learn More</a>
        </div>

<div className="main-content">
        <div className="content-wrap">

        <div className="col-narrow">
        <p className="develop-header">Develop with Newforma API</p>
        <p className="bodyP">Newforma API provides the ability to securely interact with customer project data. Create, modify and enhance Newforma project data with our APIs.</p>
        <span className="create-btn"><Register /></span>
        <span className="viewDocs-btn" href="#"><Link to='/documentation'>View Docs </Link><span className="arrow">&#8594;</span></span>
        </div>

        <div className="col-wide">
        <img src={newformaAPILogo} className="Curly-logo" alt="curly logo" />

        </div>
        </div>
        <section className="content-wrap tiles">


        <div className="col-tiles">
        <h1 className="tiles-title">Projects</h1>
        <p className="tiles-p">Quickly and easily view any NPC or Cloud projects and their files.</p>
        <Link className="tiles-btn" to='/documentation#features'>Learn More</Link>
        </div>

        <div className="col-tiles">
        <h1 className="tiles-title">Action Items</h1>
        <p className="tiles-p">Help Team Members manage their daily tasks with access to their Action Items.</p>
        <Link className="tiles-btn" to='/documentation#features'>Learn More</Link>
        </div>

        <div className="col-tiles">
        <h1 className="tiles-title">Search</h1>
        <p className="tiles-p">Quickly find files and filed email messages from any project for fast reference and answers to questions.</p>
        <Link className="tiles-btn" to='/documentation#features'>Learn More</Link>
        </div>

        <div className="col-tiles">
        <h1 className="tiles-title">Project Team</h1>
        <p className="tiles-p">Use the power of API automation to create, update and maintain your project teams.</p>
        <Link className="tiles-btn" to='/documentation#features'>Learn More</Link>
        </div>

        <div className="col-tiles">
        <h1 className="tiles-title">Contacts</h1>
        <p className="tiles-p">Keep your contacts up to date with API automation.</p>
        <Link className="tiles-btn" to='/documentation#features'>Learn More</Link>
        </div>


        </section>



        </div>

      <div className="privacy-policy">
        <a href="https://www.newforma.com/Privacy-Policy/">Privacy Policy</a>
      </div>
      </div>
</div>
)
}
}



/** WEBPACK FOOTER **
 ** ./src/pages/Home.js
 **/